import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache:false
};


export default {
    path: '/notice',
    name: 'notice',
    redirect: {
        name: 'noticeList'
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: '/notice/noticeList',
            name: 'noticeList',
            meta: {
                ...meta,
                title: '$t:menu.indexNoticeList',
                desc: '公告列表'
            },
            component: () => import('@/pages/notice/noticeList.vue')
        },
        {
            path: '/notice/noticeEdit/:id',
            name: 'noticeEdit',
            meta: {
                ...meta,
                title: '$t:menu.noticeEdit',
                desc: '编辑公告'
            },
            component: () => import('@/pages/notice/noticeEdit.vue')
        },{
            path: '/notice/noticeAdd',
            name: 'noticeAdd',
            meta: {
                ...meta,
                title: '$t:menu.noticeEdit',
                desc: '新增公告'
            },
            component: () => import('@/pages/notice/noticeEdit.vue')
        },
        {
            path: '/notice/noticeTypeList',
            name: 'noticeTypeList',
            meta: {
                ...meta,
                title: '$t:menu.noticeTypeList',
                desc: '公告类型'
            },
            component: () => import('@/pages/notice/noticeTypeList.vue')
        },
        {
            path: '/notice/noticeTypeEdit/:id',
            name: 'noticeTypeEdit',
            meta: {
                ...meta,
                title: '$t:',
                desc: '编辑公告类型'
            },
            component: () => import('@/pages/notice/noticeTypeEdit.vue')
        },
        {
            path: '/notice/indexNoticeList',
            name: 'indexNoticeList',
            meta: {
                ...meta,
                title: '$t:menu.indexNoticeList',
                desc: '公告列表'
            },
            component: () => import('@/pages/notice/indexNoticeList.vue')
        },
        {
            path: '/notice/indexNoticeDetail',
            name: 'indexNoticeDetail',
            meta: {
                ...meta,
                title: '$t:menu.indexNoticeDetail',
                desc: '公告详情'
            },
            component: () => import('@/pages/notice/indexNoticeDetail.vue')
        },
		{
            path: '/notice/noticeTypeEdit',
            name: 'noticeTypeAdd',
            meta: {
                ...meta,
                title: '新增公告类型'
            },
            component: () => import('@/pages/notice/noticeTypeEdit.vue')
        },
    ]
};
